/* ============================================================
   NEXORA theme JS — vanilla, no dependencies.
   Cart drawer (AJAX), variant + bundle logic, reveals,
   carousels, accordions, before/after, sticky ATC, menu.
   ============================================================ */
(function(){
  "use strict";
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = (window.Nexora && window.Nexora.routes) || {};
  var money = (window.Nexora && window.Nexora.moneyFormat) || '${{amount}}';

  function $(s,c){return (c||document).querySelector(s);}
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function on(el,ev,fn){ if(el) el.addEventListener(ev,fn); }
  function formatMoney(cents){
    try{
      var v=(cents/100).toFixed(2);
      return money.replace(/\{\{\s*amount\s*\}\}/, v);
    }catch(e){return '$'+(cents/100).toFixed(2);}
  }

  /* ---------- Twinkling stars ---------- */
  $$('.nx-stars').forEach(function(layer){
    if(RM) return;
    var n = parseInt(layer.getAttribute('data-count')||'40',10);
    var frag=document.createDocumentFragment();
    for(var i=0;i<n;i++){
      var s=document.createElement('i');
      s.style.left=(Math.random()*100)+'%';
      s.style.top=(Math.random()*100)+'%';
      s.style.animationDelay=(Math.random()*4)+'s';
      s.style.transform='scale('+(0.5+Math.random()*1.4)+')';
      frag.appendChild(s);
    }
    layer.appendChild(frag);
  });

  /* ---------- Reveal on scroll ---------- */
  var reveals=$$('.nx-reveal');
  if(reveals.length){
    if(RM || !('IntersectionObserver' in window)){
      reveals.forEach(function(el){el.classList.add('is-in');});
    }else{
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}
        });
      },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
      reveals.forEach(function(el){io.observe(el);});
    }
  }

  /* ---------- Mobile menu ---------- */
  var menu=$('[data-mobile-menu]');
  on($('[data-menu-open]'),'click',function(){ if(menu){menu.classList.add('is-open');document.body.style.overflow='hidden';} });
  on($('[data-menu-close]'),'click',function(){ if(menu){menu.classList.remove('is-open');document.body.style.overflow='';} });

  /* ---------- Accordions ---------- */
  $$('.nx-acc__q').forEach(function(btn){
    on(btn,'click',function(){
      var expanded=btn.getAttribute('aria-expanded')==='true';
      btn.setAttribute('aria-expanded',String(!expanded));
      var panel=btn.nextElementSibling;
      if(panel){ panel.style.maxHeight = expanded ? '0px' : (panel.scrollHeight+'px'); }
    });
  });

  /* ---------- Carousel arrows ---------- */
  $$('[data-carousel]').forEach(function(car){
    var track=$('[data-track]',car);
    if(!track) return;
    function step(){ var card=track.firstElementChild; return card?card.getBoundingClientRect().width+16:300; }
    on($('[data-prev]',car),'click',function(){ track.scrollBy({left:-step(),behavior:RM?'auto':'smooth'}); });
    on($('[data-next]',car),'click',function(){ track.scrollBy({left:step(),behavior:RM?'auto':'smooth'}); });
  });

  /* ---------- Lazy video play/pause + controls ---------- */
  $$('[data-nx-video]').forEach(function(wrap){
    var vid=$('video',wrap);
    if(!vid) return;
    var playBtn=$('[data-vplay]',wrap), muteBtn=$('[data-vmute]',wrap);
    if('IntersectionObserver' in window && !RM){
      var vio=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting && vid.autoplay){ vid.play().catch(function(){}); }
          else { vid.pause(); }
        });
      },{threshold:.35});
      vio.observe(wrap);
    }
    on(playBtn,'click',function(){
      if(vid.paused){vid.play();playBtn.setAttribute('aria-label','Pause');}
      else{vid.pause();playBtn.setAttribute('aria-label','Play');}
    });
    on(muteBtn,'click',function(){
      vid.muted=!vid.muted;
      muteBtn.setAttribute('aria-label',vid.muted?'Unmute':'Mute');
      muteBtn.classList.toggle('is-muted',vid.muted);
    });
  });

  /* ---------- Before / After slider ---------- */
  $$('[data-ba]').forEach(function(ba){
    var after=$('.nx-ba__after',ba), handle=$('.nx-ba__handle',ba);
    if(!after||!handle) return;
    function setPos(x){
      var r=ba.getBoundingClientRect();
      var pct=Math.max(0,Math.min(100,((x-r.left)/r.width)*100));
      after.style.clipPath='inset(0 0 0 '+pct+'%)';
      handle.style.left=pct+'%';
    }
    var dragging=false;
    on(handle,'pointerdown',function(){dragging=true;});
    on(window,'pointerup',function(){dragging=false;});
    on(ba,'pointermove',function(e){ if(dragging) setPos(e.clientX); });
    on(ba,'click',function(e){ setPos(e.clientX); });
    on(handle,'keydown',function(e){
      var cur=parseFloat(handle.style.left)||50;
      if(e.key==='ArrowLeft'){cur-=4;} else if(e.key==='ArrowRight'){cur+=4;} else return;
      cur=Math.max(0,Math.min(100,cur));
      after.style.clipPath='inset(0 0 0 '+cur+'%)';handle.style.left=cur+'%';
    });
  });

  /* ---------- Bundle / offer selector (homepage offer) ---------- */
  $$('[data-bundles]').forEach(function(group){
    var items=$$('.nx-bundle',group);
    var hidden=$('[data-bundle-variant]',group);
    items.forEach(function(item){
      on(item,'click',function(){
        items.forEach(function(i){i.classList.remove('is-active');i.setAttribute('aria-checked','false');});
        item.classList.add('is-active');item.setAttribute('aria-checked','true');
        if(hidden && item.getAttribute('data-variant-id')) hidden.value=item.getAttribute('data-variant-id');
      });
      on(item,'keydown',function(e){ if(e.key===' '||e.key==='Enter'){e.preventDefault();item.click();} });
    });
  });

  /* ---------- Product variant selector ---------- */
  $$('[data-product-form]').forEach(function(form){
    var dataEl=$('[data-variants-json]',form);
    if(!dataEl) return;
    var variants=[];
    try{ variants=JSON.parse(dataEl.textContent); }catch(e){ variants=[]; }
    var selects=$$('[data-option-selector]',form);
    var idField=$('[name="id"]',form);
    var priceNow=$('[data-price-now]',form);
    var priceWas=$('[data-price-was]',form);
    var atc=$('[data-atc]',form);

    function currentVariant(){
      var chosen=selects.map(function(s){return s.value;});
      return variants.find(function(v){
        return (v.options||[]).every(function(o,i){ return o===chosen[i]; });
      }) || variants[0];
    }
    function update(){
      var v=currentVariant();
      if(!v) return;
      if(idField) idField.value=v.id;
      if(priceNow) priceNow.textContent=formatMoney(v.price);
      if(priceWas){
        if(v.compare_at_price && v.compare_at_price>v.price){ priceWas.textContent=formatMoney(v.compare_at_price); priceWas.hidden=false; }
        else { priceWas.hidden=true; }
      }
      var sticky=$('[data-sticky-price]');
      if(sticky) sticky.textContent=formatMoney(v.price);
      if(atc){
        if(v.available){ atc.disabled=false; atc.querySelector('[data-atc-label]') && (atc.querySelector('[data-atc-label]').textContent='Add to cart'); }
        else { atc.disabled=true; atc.querySelector('[data-atc-label]') && (atc.querySelector('[data-atc-label]').textContent='Sold out'); }
      }
    }
    selects.forEach(function(s){ on(s,'change',update); });
    update();
  });

  /* ---------- Gallery thumbs ---------- */
  $$('[data-gallery]').forEach(function(g){
    var main=$('[data-gallery-main]',g);
    $$('[data-thumb]',g).forEach(function(t){
      on(t,'click',function(){
        $$('[data-thumb]',g).forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
        var src=t.getAttribute('data-full');
        if(main && src) main.innerHTML='<img src="'+src+'" alt="'+(t.getAttribute('data-alt')||'')+'">';
      });
    });
  });

  /* ===========================================================
     AJAX CART DRAWER
     =========================================================== */
  var drawer=$('[data-cart-drawer]'), overlay=$('[data-cart-overlay]');
  function openDrawer(){ if(drawer){drawer.classList.add('is-open');overlay.classList.add('is-open');document.body.style.overflow='hidden';drawer.setAttribute('aria-hidden','false');} }
  function closeDrawer(){ if(drawer){drawer.classList.remove('is-open');overlay.classList.remove('is-open');document.body.style.overflow='';drawer.setAttribute('aria-hidden','true');} }
  $$('[data-cart-toggle]').forEach(function(b){ on(b,'click',function(e){e.preventDefault();fetchCart();openDrawer();}); });
  on(overlay,'click',closeDrawer);
  $$('[data-cart-close]').forEach(function(b){ on(b,'click',closeDrawer); });
  on(document,'keydown',function(e){ if(e.key==='Escape'){closeDrawer();} });

  function threshold(){ return parseInt((drawer&&drawer.getAttribute('data-free-threshold'))||'0',10); }

  function renderCart(cart){
    var body=$('[data-cart-items]'); if(!body) return;
    $$('[data-cart-count]').forEach(function(c){ c.textContent=cart.item_count; c.hidden=cart.item_count===0; });
    var subtotalEl=$('[data-cart-subtotal]'); if(subtotalEl) subtotalEl.textContent=formatMoney(cart.total_price);
    // free shipping bar
    var th=threshold();
    if(th>0){
      var bar=$('[data-ship-fill]'), msg=$('[data-ship-msg]');
      var pct=Math.min(100,(cart.total_price/th)*100);
      if(bar) bar.style.width=pct+'%';
      if(msg){
        if(cart.total_price>=th){ msg.innerHTML='🎉 You\u2019ve unlocked <b>free shipping</b>!'; }
        else { msg.innerHTML='You\u2019re <b>'+formatMoney(th-cart.total_price)+'</b> away from free shipping'; }
      }
    }
    if(!cart.items.length){
      body.innerHTML='<p class="nx-muted" style="text-align:center;padding:2rem 0">Your cart is empty.</p>';
      return;
    }
    body.innerHTML=cart.items.map(function(it){
      var img=it.image?it.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_120x$1'):'';
      return '<div class="nx-line-item" data-key="'+it.key+'">'+
        (img?'<img src="'+img+'" alt="'+it.product_title+'">':'<div class="nx-line-item__img"></div>')+
        '<div style="flex:1"><b>'+it.product_title+'</b>'+
        (it.variant_title&&it.variant_title!=='Default Title'?'<div class="nx-muted" style="font-size:.82rem">'+it.variant_title+'</div>':'')+
        '<div class="nx-line-item__qty"><button data-dec aria-label="Decrease">\u2212</button><span style="padding:0 .6rem;align-self:center">'+it.quantity+'</span><button data-inc aria-label="Increase">+</button></div>'+
        '</div><div style="text-align:right"><b>'+formatMoney(it.final_line_price)+'</b><br><button data-remove class="nx-muted" style="background:none;border:0;font-size:.78rem;text-decoration:underline;color:inherit">Remove</button></div></div>';
    }).join('');
    bindLineItems();
  }
  function bindLineItems(){
    $$('[data-key]','[data-cart-items]'===null?document:$('[data-cart-items]')).forEach(function(){});
    $$('.nx-line-item').forEach(function(li){
      var key=li.getAttribute('data-key');
      var qtyEl=$('span',$('.nx-line-item__qty',li));
      var q=qtyEl?parseInt(qtyEl.textContent,10):1;
      on($('[data-inc]',li),'click',function(){changeQty(key,q+1);});
      on($('[data-dec]',li),'click',function(){changeQty(key,q-1);});
      on($('[data-remove]',li),'click',function(){changeQty(key,0);});
    });
  }
  function fetchCart(){
    fetch((routes.cart_url||'/cart')+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();}).then(renderCart).catch(function(){});
  }
  function changeQty(key,qty){
    fetch((routes.cart_change_url||'/cart/change')+'.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})
    }).then(function(r){return r.json();}).then(renderCart).catch(function(){});
  }
  // Intercept product add-to-cart forms
  $$('form[action*="/cart/add"]').forEach(function(form){
    on(form,'submit',function(e){
      e.preventDefault();
      var btn=form.querySelector('[type="submit"]');
      if(btn){btn.disabled=true;btn.classList.add('is-loading');}
      var fd=new FormData(form);
      fetch((routes.cart_add_url||'/cart/add')+'.js',{
        method:'POST',headers:{'Accept':'application/json'},body:fd
      }).then(function(r){return r.json();}).then(function(){
        fetchCart();openDrawer();
      }).catch(function(){ form.submit(); }).finally(function(){
        if(btn){btn.disabled=false;btn.classList.remove('is-loading');}
      });
    });
  });
  // initial count
  fetchCart();

  /* ---------- Sticky mobile ATC ---------- */
  var sticky=$('[data-sticky-atc]');
  if(sticky){
    var anchor=$('[data-atc-anchor]');
    if(anchor && 'IntersectionObserver' in window){
      var sio=new IntersectionObserver(function(es){
        es.forEach(function(e){ sticky.classList.toggle('is-show', !e.isIntersecting && e.boundingClientRect.top<0); });
      });
      sio.observe(anchor);
    }
    on($('[data-sticky-add]',sticky),'click',function(){
      var mainForm=$('[data-product-form]');
      if(mainForm){ mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.submit(); }
    });
  }

  /* ---------- Quantity steppers ---------- */
  $$('[data-qty]').forEach(function(box){
    var input=$('input',box);
    if(!input) return;
    on($('[data-qty-minus]',box),'click',function(){
      var v=Math.max(1,(parseInt(input.value,10)||1)-1); input.value=v;
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
    on($('[data-qty-plus]',box),'click',function(){
      var v=Math.max(1,(parseInt(input.value,10)||1)+1); input.value=v;
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });

  /* ---------- Predictive search (graceful) ---------- */
  var searchInput=$('[data-predictive]');
  var resultsBox=$('[data-predictive-results]');
  if(searchInput && resultsBox && routes.predictive_search_url){
    var t;
    on(searchInput,'input',function(){
      clearTimeout(t);
      var q=searchInput.value.trim();
      if(q.length<2){resultsBox.innerHTML='';resultsBox.hidden=true;return;}
      t=setTimeout(function(){
        fetch(routes.predictive_search_url+'?q='+encodeURIComponent(q)+'&resources[type]=product&section_id=predictive-search',{headers:{'Accept':'text/html'}})
          .then(function(r){return r.text();}).then(function(html){ resultsBox.innerHTML=html;resultsBox.hidden=false; })
          .catch(function(){});
      },220);
    });
  }
})();
